import neighborhoods from "@/constants/neighborhoods";
import companies from "@/constants/companies";

const locations = [...neighborhoods, ...companies];

const useNeighborhood = () => {
    const getNeighborhoodName = (slug?: string): string => {
        if (!slug) return 'No especificado';
        const neighborhood = locations.find((neigh) => neigh.slug === slug);
        return neighborhood ? neighborhood.title : slug;
    };

    const getNeighborhoodId = (slug: string): string => {
        if (!slug) return '';
        const neighborhood = locations.find((neigh) => neigh.slug === slug);
        return neighborhood ? neighborhood.slug : slug;
    }
    
    const getNeighborhood = (slug?: string) => {
        if (!slug) return null;
        return locations.find((neigh) => neigh.slug === slug) || null;
    }

    return {
        getNeighborhood,
        getNeighborhoodName,
        getNeighborhoodId,
    };
}

export default useNeighborhood;
